import { Card } from "antd";

import styles from "@/components/Dashboard/Card/Card.module.css";

interface StatCardProps {
  title: string;
  value: string;
  footer?: string;
  color?: string;
  icon: string;
  subTitle?: string;
  bgImage?: string;
}

const StatCard = ({ title, value, footer, color, subTitle, bgImage, icon }: StatCardProps) => {
  return (
    <Card
      variant="borderless"
      className={`${bgImage ? styles.card : styles.cardDark}`}
      // Background is set inline because it depends on dynamic props (bgImage/color)
      style={{
        background: bgImage
          ? `url(${bgImage}) center/cover no-repeat${color ? `, ${color}` : ""}`
          : color || "transparent",
      }}
    >
      <div className={styles.headerRow}>
        <div className={`${bgImage ? styles.iconWrapper : styles.darkIconWrapper}`}>
          <img src={icon} alt="icon" />
        </div>
        <div className={styles.textWrapper}>
          <span className={`${bgImage ? styles.cardTitle : styles.darkCardTitle}`}>{title}</span>
          <p className={styles.subTitle}>{subTitle}</p>
        </div>
      </div>

      <div className={styles.footerOptions}>
        <h2 className={styles.value}>{value}</h2>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </Card>
  );
};

export default StatCard;
